/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Input } from "semantic-ui-react";
import { headerFields } from "../../utils/constant";
import OrderImportFile from './orderImportModal'

const TitleBar = (props) => {
  const [ImportModalState, setImportModalState] = useState(false);
  const handleImportOpen = () => {
    setImportModalState(true);
  };

  const handleImportClose = () => {
    setImportModalState(false);
    window.location.reload();
  };
  return (
    <div id="dispatch_bar">
      <div className="container-fluid dip_bar">
        <div className="row">
          <div className="col-sm-12">
            <div className="d-flex justify-content-between">
              <h2 className="page-title">{props.title}</h2>
              <div className="form-inline">
              {props?.hideImport == true
                    ?
                    null
                    :
                    <button
                      type="button"
                      data-toggle="modal"
                      data-target="#ImportXL"
                      onClick={() => handleImportOpen()}
                      className="grey-btn"
                    >
                      <i class="fas fa-file-import mr-1"></i>
                      {headerFields.IMPORT}
                    </button>
                  }
                <Input size="mini" icon={{ name: 'search', circular: true }} onKeyUp={props.handleSearch} className="mr-1 ml-1" placeholder={"Search"} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <OrderImportFile
        openBox={ImportModalState}
        handleClose={handleImportClose}
        fileName={props.baseURL}
        baseURL={props.baseURL}
        allotedOrder={true}
      />
    </div>
  );
};

export default TitleBar;
